import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { data, images } from '../../constants';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import './Menu.css';

const Menu = () => {
    return (
            <Navbar collapseOnSelect expand="lg" className="site-navbar" sticky="top">
                <Container className="site-nav-container">
                    <Navbar.Brand href="#home" className="brand-lockup" aria-label="SmartSastram home">
                        <img src={images.logo} alt="SmartSastram" className="brand-logo" />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
                        <Nav className="site-nav-links">
                            {data.Menu.slice(0, 1).map((item, index) => (
                                <Nav.Link href={item.link} key={index}>{item.text}</Nav.Link>
                            ))}
                            <NavDropdown title="Initiatives" id="initiatives-dropdown" className="initiatives-dropdown">
                                {data.ProductMenu.map((group) => (
                                    <div className="nav-dropdown-group" key={group.group}>
                                        <span>{group.group}</span>
                                        {group.products.map((product) => (
                                            <NavDropdown.Item href={product.link} key={product.name}>
                                                <strong>{product.name}</strong>
                                                <small>{product.description}</small>
                                            </NavDropdown.Item>
                                        ))}
                                    </div>
                                ))}
                            </NavDropdown>
                            {data.Menu.slice(1).map((item, index) => (
                                <Nav.Link href={item.link} key={item.text}>{item.text}</Nav.Link>
                            ))}
                            <Nav.Link href="#quote" className="nav-cta">Start a conversation <FiArrowRight /></Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
    )
}

export default Menu
